/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Scope } from 'informed';
import { Button as RMDButton, Cell, Grid } from 'react-md';
import { withStyles } from '@material-ui/core/styles';
import { compact, defaultTo, get, isEqual } from 'lodash-es';

import HiddenField from '../../Common/HiddenField';
// import HiddenField from '../../Common/HiddenField';
import Select from '../../Common/Select';
import ValidationMessage from '../../Common/ValidationMessage';
import BillingFields from './BillingFields';
import ExtendedPartyFields from './ExtendedPartyFields';
import PartyFields from './PartyFields';

import './TransformBlock.scss';

/**
 * @class TransformBlock
 */
class TransformBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: '',
      selectedValueSubscriber: undefined,
      expanded: true,
      actionsState: {
        btn: {
          cancel: {
            disable: false,
          },
          subscribe: {
            disable: false,
          },
          putonhold: {
            disable: false,
          },
        },
      },
    };
  }

  static componentDidMount() {
    const { expanded } = this.props;
    this.setState({
      expanded,
    });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { expanded, actionsState: nextActionsState, values: nextValues } = nextProps;
    const { actionsState: prevActionsState, selectedValueSubscriber: prevSelectedValueSubscriber } = prevState;
    // const { binder } = prevState;
    let newState = null;
    if (expanded !== prevState.expanded) {
      newState = newState ? Object.assign(newState, { expanded }) : { expanded };
    }
    if (!isEqual(Object.assign(prevActionsState, nextActionsState), prevActionsState)) {
      newState = newState
        ? Object.assign(newState, {
            actionsState: Object.assign(prevActionsState, nextActionsState),
          })
        : { actionsState: Object.assign(prevActionsState, nextActionsState) };
    }
    if (
      typeof prevSelectedValueSubscriber === 'undefined' &&
      prevSelectedValueSubscriber !== get(nextValues, 'transform.subscriber')
    ) {
      newState = { ...newState, selectedValueSubscriber: get(nextValues, 'transform.subscriber', -1) };
    }
    return newState;
  }

  componentDidUpdate(prevProps, prevState) {
    const { binder } = this.state;
    if (prevState.binder !== binder) {
      this.deepCleanValues();
    }
  }

  deepCleanValues = (property = 'covered') => {
    const { formApi } = this.props;
    // const { type } = this.state;
    const propertyState = defaultTo(formApi.getValue(property), []);
    const cleanPropertyState = compact(propertyState);

    formApi.setValues({ ...formApi.getState().values, [property]: compact(cleanPropertyState) });
  };

  render() {
    const { expanded, selectedValue, actionsState, selectedValueSubscriber } = this.state;
    const {
      actions,
      formApi,
      formState,
      onSubscribe,
      onPutOnHold,
      onCancel,
      strings,
      classes,
      config,
      values,
      setExpanded,
      data,
      readOnly,
      apiBaseUrl,
      validate,
      defaultValues,
    } = this.props;

    const subscriberKind = get(data, 'subscriber_kind');

    // eslint-disable-next-line no-unused-vars
    const handleSubscribe = value => {
      this.setState({
        selectedValue: value,
      });
      onSubscribe(formApi.getState().values);
    };

    // eslint-disable-next-line no-unused-vars
    const handlePutOnHold = value => {
      this.setState({
        selectedValue: value,
      });
      onPutOnHold(formApi.getState().values);
    };

    // eslint-disable-next-line no-unused-vars
    const handleCancel = value => {
      this.setState({
        selectedValue: value,
      });
      onCancel(formApi.getState().values);
    };

    const toggleExpanded = () => {
      setExpanded('transform', !expanded);
    };

    const getSubsciberField = () => {
      const { covered } = values;
      // used party if is defined then display select
      if (Array.isArray(covered)) {
        const options = [];
        covered.forEach((c, key) => {
          if (c.party && c.party.name && c.party.first_name && c.party.birth_date && c.party.gender) {
            options.push({
              value: key,
              text: `${c.party.first_name} ${c.party.name}`,
            });
          }
        });
        options.push({
          value: -1,
          text: get(strings, 'block.transform.subscriber.new-subscriber', 'Autre souscripteur...'),
        });
        if (options.length > 1) {
          const selectedSubscriber =
            typeof selectedValueSubscriber !== 'undefined' && selectedValueSubscriber !== -1
              ? { ...get(covered, `[${selectedValueSubscriber}].party`), key: selectedValueSubscriber }
              : undefined;

          // console.log(selectedSubscriber, selectedValueSubscriber, get(transform, 'subscriber'));
          return (
            <Grid
              className="grid"
              style={{
                width: '100%',
              }}
            >
              <div key="name" className={Cell.getClassName({ size: 12 })}>
                {subscriberKind === 'company' ? (
                  <HiddenField field="subscriber" initialValue={-1} />
                ) : (
                  <Select
                    className="field select"
                    key="subscriber"
                    field="subscriber"
                    id="select-subscriber"
                    name="subscriber"
                    shrink
                    label={strings['block.transform.party.field.select.label']}
                    options={options}
                    onChange={value => {
                      this.setState({ selectedValueSubscriber: value });
                    }}
                    value={selectedValueSubscriber}
                    initialValue={selectedValueSubscriber}
                    disabled={readOnly}
                  />
                )}
                {selectedSubscriber ? undefined : (
                  <PartyFields
                    formState={formState}
                    strings={strings}
                    config={config}
                    readOnly={readOnly}
                    subscriberKind={subscriberKind}
                  />
                )}
              </div>
            </Grid>
          );
        }
      }
      // else display empty form "party"
      return (
        <PartyFields
          cellSize={12}
          strings={strings}
          config={config}
          readOnly={readOnly}
          subscriberKind={subscriberKind}
        />
      );
    };

    const getExtendPartyFields = () => {
      const { selectedValueSubscriber: selectedSubscriber } = this.state;
      return (
        <ExtendedPartyFields
          key={`phone-email-${selectedSubscriber}`}
          values={values.transform}
          strings={strings}
          selectedPackage={selectedValue}
          readOnly={readOnly}
          subscriberKind={subscriberKind}
          selectedValueSubscriber={selectedSubscriber}
        />
      );
    };

    const getBillingFields = () => (
      <BillingFields
        billingModes={data.billingModes}
        values={values.transform}
        strings={strings}
        logout={actions.logout}
        banks={config.covered ? config.covered.banks : []}
        readOnly={readOnly}
        apiBaseUrl={apiBaseUrl}
        validateIban={actions.validateIban}
        formApi={formApi}
        defaultValues={defaultValues}
      />
    );

    return (
      <ExpansionPanel
        className={`expansion-panel ${expanded ? 'expanded' : ''}`}
        expanded={expanded}
        onChange={toggleExpanded}
      >
        <ExpansionPanelSummary
          className="expansion-panel-summary"
          expandIcon={<ExpandMoreIcon className="expansion-more-icon" />}
        >
          <span className="extra-block-title">{strings['block.transform.title']}</span>
          {/* {summary(values.extra)} */}
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={classes.details}>
          <div className="transform details">
            <div className="list">
              <Scope scope="transform">
                {/* tips: to create array in scope => scope= {`extra[${index}]` */}
                <div className="page subscriber">
                  <div className="title--sub-block">{strings['block.transform.subscriber.title']}</div>
                  {getSubsciberField()}
                  {getExtendPartyFields()}
                </div>
                <div className="page billing">
                  <div className="title--sub-block">{strings['block.transform.billing.title']}</div>
                  {getBillingFields()}
                </div>
              </Scope>
            </div>
          </div>
        </ExpansionPanelDetails>
        <Divider />
        <ExpansionPanelActions className="block actions">
          <div className="button-block">
            <RMDButton
              raised
              className="danger action-subscribe"
              secondary
              iconBefore={false}
              // swapTheming
              iconChildren="check_circle_outline"
              onClick={handleSubscribe}
              disabled={get(actionsState, 'btn.subscribe.disable', readOnly)}
              title={get(strings, 'block.transform.btn.subscribe.label')}
            >
              {strings['block.transform.btn.subscribe.label']}
            </RMDButton>
            <RMDButton
              raised
              className="danger action-cancel"
              iconBefore={false}
              swapTheming
              iconChildren="cancel"
              onClick={handleCancel}
              disabled={get(actionsState, 'btn.cancel.disable', readOnly)}
              title={get(strings, 'block.transform.btn.cancel.label')}
            >
              {get(strings, 'block.transform.btn.cancel.label')}
            </RMDButton>
          </div>
          <ValidationMessage validate={validate} path="subscription" />
        </ExpansionPanelActions>
      </ExpansionPanel>
    );
  }
}

TransformBlock.propTypes = {
  formApi: PropTypes.any.isRequired, // eslint-disable-line
  data: PropTypes.any.isRequired, // eslint-disable-line
  onSave: PropTypes.func.isRequired, // eslint-disable-line
  onSubscribe: PropTypes.func.isRequired, // eslint-disable-line
  onPutOnHold: PropTypes.func.isRequired, // eslint-disable-line
  onPrint: PropTypes.func.isRequired, // eslint-disable-line
  onCancel: PropTypes.func.isRequired, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
  classes: PropTypes.any.isRequired, // eslint-disable-line
  config: PropTypes.any.isRequired, // eslint-disable-line
  values: PropTypes.any.isRequired, // eslint-disable-line
  actions: PropTypes.shape({
    fetchBanks: PropTypes.func,
    logout: PropTypes.func,
    validateIban: PropTypes.func,
  }).isRequired,
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
  actionsState: PropTypes.any, // eslint-disable-line
  readOnly: PropTypes.bool.isRequired,
  apiBaseUrl: PropTypes.string.isRequired,
  validate: PropTypes.object.isRequired, // eslint-disable-line
  defaultValues: PropTypes.object, // eslint-disable-line
};

TransformBlock.defaultProps = {
  actionsState: {
    btn: {
      cancel: {
        disable: false,
      },
      subscribe: {
        disable: false,
      },
      putonhold: {
        disable: false,
      },
    },
  },
  defaultValues: undefined,
};

const styles = theme => ({
  root: {},
  formControl: {},
  selectEmpty: {},
  button: {},
  input: {},
  details: {
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
    },
  },
});

export default withStyles(styles)(TransformBlock);
